import axios from 'axios';

const loadUserWalletApi = async (values, token, langIsoCode) => {
  const url = '/Wallet/loadWallet';
  try {
    const res = await axios.post(url, values, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default loadUserWalletApi;
